import awsmobile from './aws-exports';

import { toSentenceCase, losAngelesToUCLA } from './utils';
import { GENERIC_NETWORK_ERROR, BACKEND_VALIDATION_ERROR } from './errors';

export const ITEMS_PER_PAGE = 10;

const TERM_OPTIONS_FOR_SEARCH = [
  { id: 1, name: 'Fall' },
  { id: 2, name: 'Winter/Spring' }
];

export const FALL_TERM = 1;
export const SPRING_TERM = 2;
export const WINTER_TERM = 3;

const URL = awsmobile.aws_cloud_logic_custom[0].endpoint;
//const URL = 'http://localhost:3000';
const sortFunction = (a, b) => a.sort_order > b.sort_order ? 1 : -1;

export const fetchFormOptions = () =>  {
  const request = new Request(URL + '/formoptions');

  return fetch(request).then(res => {
    if (!(res.body || res.ok)) {
      return Promise.reject(GENERIC_NETWORK_ERROR);
    }
    return res.json();
  }).then(json => {
    if (json.statusCode && json.statusCode !== 200) {
      return Promise.reject(GENERIC_NETWORK_ERROR);
    }

    const { campus, discipline, level, years } = json.options;
    const campuses = campus.sort(sortFunction)
      .map(c => ({id: c.campus_id, name: losAngelesToUCLA(c.name)}))
    const categories = discipline.sort(sortFunction)
      .map(d => ({id: d.discipline_id, name: d.name}))
      .filter(c => c.name !== '--');
    const applicantLevels = level.sort(sortFunction)
      .map(l => ({id: l.level_id, name: l.name}))
      .map(l => ({id: l.id, name: toSentenceCase(l.name)}));

    const yearsList = years.reduce((list, year) => {
      list[year.year_id] = {
        [FALL_TERM]: year.name.slice(0, -5),
        [WINTER_TERM]: year.name.slice(5),
        [SPRING_TERM]: year.name.slice(5)
      };

      return list;
    }, {});

    const formOptions = {
      campuses,
      categories,
      applicantLevels,
      terms: TERM_OPTIONS_FOR_SEARCH,
      yearsList
    };

    return formOptions;
  }).catch(error => Promise.reject(GENERIC_NETWORK_ERROR))
};

// Date Spoofing for testing
let SPOOFED_DATE = null;

window.UGM_setDate = (month, day, year) => {
  // UGM_setDate(month, day, year) <--- usage
  //
  SPOOFED_DATE = new Date(year, month - 1, day, 12);
  console.log('custom date: ', SPOOFED_DATE);
}
window.UGM_getDate = () => {
  // UGM_getDate() <--- usage
  //
  return SPOOFED_DATE;
}
window.UGM_clearDate = () => {
  // UGM_clearDate() <--- usage
  //
  SPOOFED_DATE = null;
  console.log('custom date cleared');
}

export const searchForMajors = params => {
  // add in a spoofed date if we have one
  if (SPOOFED_DATE && ! isNaN(SPOOFED_DATE)) {
    params.date = SPOOFED_DATE.toISOString();
  }

  const request = new Request(URL + '/search', {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(params)
  });

  return fetch(request).then(res => {
    if (!(res.body || res.ok)) {
      return Promise.reject(GENERIC_NETWORK_ERROR);
    }
    return res.json();
  }).catch(error =>  {
    return Promise.reject(GENERIC_NETWORK_ERROR)
  })
    .then(json => {
      if (json.statusCode && json.statusCode !== 200) {
        if (json.validationError) {
          return Promise.reject(BACKEND_VALIDATION_ERROR);
        } else if (json.dateError) {
          return Promise.reject(BACKEND_VALIDATION_ERROR);
        } else {
          return Promise.reject(GENERIC_NETWORK_ERROR);
        }
      }

      return json.data;
    });
};
